import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import Dropdown from './dropdown';
import { CalendarApiModel } from '../redux/reducers/calendar-api';
import { CalendarAppState } from '../classes/redux-states';
import { DropdownOption } from '../classes/dropdownOptions';
import * as _ from 'lodash';
import { filterEventsByCategory } from "../redux/actions/actions";

interface ExternalProps {
}

interface StateToProps {
    currentCategory: string;
    updating: boolean;

}

interface DispatchToProps {
    filterEvents: (category: string) => any;
}

type CategoryDropdownProps = ExternalProps & StateToProps & DispatchToProps;

interface CategoryDropdownState {
    dropdownOptions: Array<DropdownOption>;
}

class CategoryDropdown extends React.Component<CategoryDropdownProps, CategoryDropdownState>  {
    constructor(props: CategoryDropdownProps) {
        super(props);

        let categories: Array<DropdownOption> = [];
        categories.push(
            {
                text: "All Categories",
                value: "allcategories"
            });
        categories.push(
            {
                text: "AAPD CE Courses",
                value: "aapdcecourses"
            });
        categories.push(
            {
                text: "AAPD Governance Meetings",
                value: "aapdgovernancemeetings"
            });
        categories.push(
            {
                text: "State and District CE Courses",
                value: "stateanddistrictcecourses"
            });
        categories.push(
            {
                text: "General Events",
                value: "generalevents"
            });
        categories.push(
            {
                text: "Future Annual Session",
                value: "futureannualsession"
            });

        this.state = {
            dropdownOptions: categories,
        };

    }

    onChange(newValue: string) {
        this.props.filterEvents(newValue);
        
    }

    render() {
      return (
        <Dropdown selected={this.props.currentCategory} onChange={this.onChange.bind(this)} name="Meeting and Education Type" options={this.state.dropdownOptions} />
      )
    }
}

function mapStateToProps(state: CalendarAppState, externalProps: ExternalProps): StateToProps {
    return {
        currentCategory: state.calendarApiModel.selectedCategory,
        updating: state.calendarApiModel.requestingEvents
    };
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>): DispatchToProps {
    return {
        filterEvents: (category: string) => dispatch(filterEventsByCategory(category))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDropdown);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/category-filter.tsx